import Rx from 'rxjs'; // eslint-disable-line

import { getStore } from '../store';
import * as selectors from '../selectors';
import actiontypes from '../actiontypes';
import * as actions from '../actions';
import * as apicalls from '../api';

export const initiateFetchInstitutionsEpic = action$ =>
    action$
        .ofType(actiontypes.SET_FILTERS)
        .debounceTime(400)
        .filter(
            action =>
                action.payload.freetext ||
                '' ||
                (action.payload.categories || []).length ||
                (action.payload.districts || []).length
        )
        .map(action => actions.fetchInstitutions(action.payload));

export const fetchInstitutionsEpic = action$ =>
    action$
        .ofType(actiontypes.FETCH_INSTITUTIONS)
        .debounceTime(500)
        .distinctUntilChanged()
        .mergeMap(action => {
            return Rx.Observable
                .fromPromise(
                    apicalls
                        .loadInstitutions(
                            selectors.userToken(getStore().getState()),
                            action.payload
                        )
                        .then(result => result.json())
                )
                .map(json => actions.fetchedInstitutions(json));
        });

export const fetchingInstitutionsEpic = action$ =>
    action$.ofType(actiontypes.FETCH_INSTITUTIONS).mapTo(actions.fetchingInstitutions());

export const fetchInstitutionEpic = action$ =>
    action$.ofType(actiontypes.FETCH_INSTITUTION).mergeMap(action => {
        return Rx.Observable
            .fromPromise(
                apicalls
                    .loadInstitution(selectors.userToken(getStore().getState()), action.payload)
                    .then(result => result.json())
            )
            .map(json => actions.fetchedInstitution(json));
    });

export const fetchingInstitutionEpic = action$ =>
    action$
        .ofType(actiontypes.FETCH_INSTITUTION)
        .mapTo(actions.fetchingInstitution(action$.payload));



/** WEBPACK FOOTER **
 ** ./src/epics/institutions.js
 **/